/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Reality_Hradec_KraloveInputs */

const cs_enum_reality_hradec_kralove = /** @type {(inputs: Enum_Reality_Hradec_KraloveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reality Hradec Králové`)
};

const en_enum_reality_hradec_kralove = /** @type {(inputs: Enum_Reality_Hradec_KraloveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reality Hradec Králové`)
};

/**
* | output |
* | --- |
* | "Reality Hradec Králové" |
*
* @param {Enum_Reality_Hradec_KraloveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_reality_hradec_kralove = /** @type {((inputs?: Enum_Reality_Hradec_KraloveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Reality_Hradec_KraloveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_reality_hradec_kralove(inputs)
	return cs_enum_reality_hradec_kralove(inputs)
});